import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { StyledEngineProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { HelmetProvider } from 'react-helmet-async';


ReactDOM.createRoot(document.querySelector("#root")!).render(
       <HelmetProvider>
         <React.StrictMode>
           <StyledEngineProvider injectFirst>
             <BrowserRouter>
               <App data-testid="app"/>
             </BrowserRouter>
           </StyledEngineProvider>
         </React.StrictMode>
       </HelmetProvider>
       );
